import { render, staticRenderFns } from "./ChatContactAvatar.vue?vue&type=template&id=846b2d9c&scoped=true&"
import script from "./ChatContactAvatar.vue?vue&type=script&lang=js&"
export * from "./ChatContactAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ChatContactAvatar.vue?vue&type=style&index=0&id=846b2d9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846b2d9c",
  null
  
)

export default component.exports